<template>
  <div :class="(options.fix?'fix':'') + ' intelligentLoadingContainer'" v-if="loading">
    <div class="intelligentLoadingIcon">
      <div class="intelligentLoading"></div>
      <span class="intelligentLoadingTip">{{options.tips}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'intelligentLoading',
  props: {
    loading: {
      required: false,
      default: true
    },
    opts: {
      required: false,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      options: {
        tips: '智能分析中...',
        fix: false
      }
    }
  },
  watch: {
    opts: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.options = Object.assign(this.options, newValue)
      }
    },
  }
}
</script>
<style lang="less" scoped>
.intelligentLoadingContainer {
  text-align: center;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  z-index: 999;

  .intelligentLoading {
    position: relative;
    width: 100px;
    height: 60px;
    margin: auto;
  }

  .intelligentLoading::after {
    content: '';
    background-image: url(@/assets/static/images/loading.gif);
    position: absolute;
    width: 100px;
    height: 60px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    left: 0;
    right: 0;
    margin: auto;
  }

  .intelligentLoadingTip {
    font-size: 12px;
  }
}

.intelligentLoadingContainer.fix {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>